import Immutable from 'immutable';

// @ts-expect-error [MC-2850] - TS2350 - Only a void function can be called with the 'new' keyword.
export const MailingList = new Immutable.Record({
  listId: undefined,
  title: undefined,
  key: undefined,
});
